import React, { useState } from 'react';
import CalendarPolicies from './CalendarPolicies';
import RasterFiles from './RasterFiles';

const TABS = [
  { key: 'calendar', label: 'بازه‌ی تقویم', Component: CalendarPolicies },
  { key: 'rasters', label: 'فایل‌های رستر', Component: RasterFiles },
];

const AdminPanel = () => {
  const [active, setActive] = useState('calendar');
  // Mounting only the active tab keeps each one's data fetch from firing until
  // it is actually opened.
  const { Component } = TABS.find((t) => t.key === active);

  return (
    <div className="p-6 max-w-6xl mx-auto text-right" dir="rtl">
      <h1 className="text-2xl font-bold mb-6">پنل مدیریت</h1>

      <div className="flex gap-2 mb-6 border-b">
        {TABS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => setActive(key)}
            className={`px-4 py-2 -mb-px border-b-2 ${
              active === key
                ? 'border-blue-600 text-blue-600 font-semibold'
                : 'border-transparent text-gray-500'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      <Component />
    </div>
  );
};

export default AdminPanel;
